import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-image-carousel',
  templateUrl: './image-carousel.component.html',
  styleUrls: ['image-carousel.component.scss']
})
export class ImageCarouselComponent implements OnInit {

  @Input() title: string;
  @Input() images: Array<any>;
  @Input() imageIndex: number;
  @Input() imageDates: Array<any>;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/shared/image-carousel/image-carousel.component.ts